import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["href", "title"];
import { computed } from 'vue';
import LlTooltip from '@/components/LlTooltip.vue';
import { useSupportChat } from '@/composables/useSupportChat';
export default {
  __name: 'LlSupport',
  props: {
    topic: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      default: 'Link to Support'
    }
  },
  setup(__props) {
    const {
      getSupportUrl
    } = useSupportChat();
    const props = __props;
    const supportUrl = computed(() => {
      return getSupportUrl(props.topic);
    });
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      return _openBlock(), _createElementBlock("a", {
        href: supportUrl.value,
        target: "_blank",
        class: "ll-support-link",
        title: __props.tooltip
      }, [_createVNode(LlTooltip, {
        text: __props.tooltip,
        location: "top"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          icon: "mdi-help-circle",
          class: "ll-info",
          size: "small",
          color: "blue-light-4"
        })]),
        _: 1
      }, 8, ["text"])], 8, _hoisted_1);
    };
  }
};